<script setup>
import {computed, inject, onMounted, ref} from "vue";
import teamService from "@/services/team.service";
import {useStore} from "vue2-helpers/vuex";
import Avatar from "vue-avatar";
import TrackerPermissionsModal from "@/components/trackers/TrackerPermissionsModal.vue";

const store = useStore();

const tracker = inject('tracker');
const trackerId = inject('trackerId');
const permissionsModal = ref(null);
const permissionHolders = ref([]);

const canManageRoles = computed(() => tracker.userPermissions.includes('tracker-permissions-edit'));
const roles = computed(() => store.getters.roles);

onMounted(async () => {
    await store.dispatch('fetchRoles');
    const {data} = await teamService.getPermissionHolders();
    permissionHolders.value = data;

    if (roles.value.length) {
        if (!trackerId.value && !tracker.permissions.length && roles.value.length) {
            addDefaultRoles();
        }
    }
});

function addDefaultRoles() {
    tracker.permissions.push(
        {
            type: 'user',
            id: store.state.user.id,
            name: store.state.user.name,
            role: roles.value[0],
            avatar: store.state.user.avatar,
        }
    )

    let defaultRole = roles.value.find(item => item.is_default === 1);
    let group = permissionHolders.value.find(item => parseInt(item.id) === -1);

    if (defaultRole && group) {
        tracker.permissions.push(
            {
                ...group,
                role: defaultRole
            }
        );
    }
}

function setPermissions(permissions) {
    tracker.permissions = [...permissions];
}
</script>

<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="heading5 heading5--secondary">Permissions</h5>
            </b-col>

            <b-col class="text-right">
                <template v-if="canManageRoles">
                    <a @click="permissionsModal.open(tracker.permissions)" class="link text-nowrap">Manage Permissions</a>

                    <TrackerPermissionsModal
                        ref="permissionsModal"
                        @save="setPermissions"
                    />
                </template>
            </b-col>
        </b-row>

        <ul class="rows-list rows-list--summary">
            <li v-for="(permission, index) in tracker.permissions" :key="index">

                <div class="image-block image-block--rounded">
                    <Avatar
                        :username="permission.name"
                        :src="permission.avatar"
                        :size="30"
                    />
                </div>

                <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>

                <h5
                    v-if="permission.role"
                    class="heading5 heading5--secondary text-capitalize"
                    :id="'permission'+permission.id"
                >
                    {{permission.role.name}}
                    <b-tooltip :target="'permission'+permission.id" placement="right" variant="light" :title="permission.role.description"></b-tooltip>
                </h5>


                <a v-if="canManageRoles" @click="tracker.permissions.splice(index, 1)" class="link-remove link" href="#"></a>
            </li>
        </ul>
    </div>
</template>

<style scoped>

</style>
